import { SET_SERVICES } from "./actions"
import { Services } from "@/types"

const INITIAL_STATE = {
  type: SET_SERVICES,
  analytics: { active: false },
  benefits: { active: false },
  catalog: { active: false },
  communications: { active: false },
  complaints: { active: false },
  evaluations: { active: false },
  events: { active: false },
  benef_corp: { active: false },
  fullstory: { active: false },
  goals: { active: false },
  notifications: { active: false },
  profile: { active: true },
  programs: { active: false },
  recognitions: { active: false },
  surveys: { active: false },
  tasks: { active: false },
  auth: { active: true },
  insignias: { active: false },
  solicitud: { active: false },
  publicBadges: { active: false },
  admin_retos: { active: false },
  whatsapp: { active: false },
  motivy_support: { active: false },
  birthdays: { active: false },
  anniversary: { active: false },
  choose_catalog: { active: false },
  complaints_pannel: { active: false },
  workplace: { active: false },
  organization_info: { active: false },
  files_repo: { active: false },
  coverages: { active: false },
  user_event_registration: { active: false },
  ever_health: { active: false },
  is_schedule: { active: false },
  birthday_img: { active: false },
  salud_seguridad: { active: false },
  invoices: { active: false },
  suggestions: { active: false },
  maintenance: { active: false },
}

interface ServicesReducer extends Services {
  type: string
}

export default function servicesReducer(
  state: ServicesReducer = INITIAL_STATE,
  action: ServicesReducer
) {
  switch (action.type) {
    case SET_SERVICES:
      return { ...action }
    default:
      return state
  }
}
